module.exports = (__webpack_require__(7))(579);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/process/browser.js from dll-reference vendor
// module id = 609
// module chunks = 1